import { RootState } from 'redux/schemas';
import { createSelector } from '@reduxjs/toolkit';
import { RecruitmentApplication } from 'redux/schemas/models/mentoring-program-recruitments';


// eslint-disable-next-line import/prefer-default-export
export const getMentoringProgramRecruitmentApplicationsList = createSelector(
  (state: RootState) => state.models.mentorshipProgramRecruitmentApplications,
  (state, ids: number[]) => ids,
  (mentorshipProgramRecruitmentApplications: Record<number, RecruitmentApplication>, ids: number[]) => ids
    .map((id) => mentorshipProgramRecruitmentApplications[id])
    .filter(Boolean),
);
